import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const RouteDragIcon = () => {
  return (
    <Grid
      style={{
        height: `20px`,
        width: `100%`,
        display: `flex`,
        justifyContent: `center`,
        alignItems: `center`,
      }}
    >
      <Grid
        style={{
          width: `45px`,
          height: `5px`,
          backgroundColor: `${RoutalPalette.primary40}4d`,
          zIndex: 1001,
          borderRadius: `50px`,
        }}
      />
    </Grid>
  );
};
